import { createFileRoute } from '@tanstack/react-router'
import { RoleNewPage } from '@/features/roles/editor/role-new-page'

/**
 * A new role. The `role.view` guard lives on the parent layout route; creating
 * is refused by the API without `role.create`, and the list hides the button.
 * `?from=<role id>` starts the role from another one.
 */
export const Route = createFileRoute('/_authenticated/roles/new')({
  validateSearch: (search: Record<string, unknown>): { from?: string } =>
    typeof search.from === 'string' ? { from: search.from } : {},
  component: RoleNewPage,
})
